interface OktaConfig {
  issuer: string;
  clientId: string;
}

export interface Authentication {
  okta: OktaConfig;
  personaSuffix?: string;
}
